/* eslint-disable @next/next/no-img-element */
"use client";

import * as React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Collapse,
    Divider,
    Grid,
    Stack,
    SvgIcon,
    Typography,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CtaButton from "../buttonWithArrow";
import Image from "next/image";
import DynamicPillButton from "../buttonWithArrow/whatsappButton";
import { useMediaQuery } from "@mui/material";
import { CurrencySimple, useResponsiveValue } from "../../utils/helper";
import { openWhatsAppChat } from "../../utils/onWhatsApp";


// const BORDER = "#E3E6EB";
const BORDER = "#B1B1B1";
const PRIMARY_GRADIENT =
    "linear-gradient(180deg, #75C4C5 0%, #0D8196 100%)";

export default function CarInvestmentCard({
    name = "Limousine",
    title,
    image,
    roiLabel = "Expected Profit / Annual ROI - 110%",
    infoList,
    price,
    period = "/Per Month",
    onEnquire,
    surfaceColor = "#fff", roiPercentage, FleetData, setSelectedVehicle, setVehicleInfo, vehicleInfo,
    contact, setContact, setOpenEnquire, selectedVehicle, bottomLabel, pricePeriod, breakdown, openBreakdown, onToggle, type
}) {
    const isOpen = !!openBreakdown;
    const responsiveSize = useResponsiveValue({ xs: 12, md: 12, lg: 15 });

    const isSmall = useMediaQuery("(max-width:600px)");
    const isMedium = useMediaQuery("(max-width:900px)");

    let size = 18; // default
    if (isSmall) size = 12;
    else if (isMedium) size = 16;

    // const [openBreakdown, setOpenBreakdown] = React.useState(false);
    React.useEffect(() => {
        if (FleetData) {
            const data = FleetData

            const initialVehicleInfo = data.map(vehicle => ({
                id: vehicle?.id, // Use _id from the response as id
                title: vehicle?.title,
                initial: '',
                monthly: '',
                month: '',
                image: vehicle?.image
            }))

            const updatedVehicleInfo = initialVehicleInfo.map(vehicle => {
                const matchingApiResponse = data.find(
                    apiVehicle => apiVehicle._id === vehicle.id
                )
                if (matchingApiResponse) {
                    return { ...vehicle, name: matchingApiResponse.name }
                }
                return vehicle
            })

            setVehicleInfo(updatedVehicleInfo)
        }
    }, [FleetData])

    const handleEnquiryClick = (carName, regionType) => {
        // Log the car name to check if it's correct
        const matchingCar = vehicleInfo.find(item => item.title === carName)
        // Scroll to the form section
        console.log('Car matchingCar:', matchingCar) // Log the car name to check if it's correct

        setSelectedVehicle(matchingCar?.id)

        if (matchingCar && matchingCar !== undefined) {
            setContact(prevState => ({
                ...prevState,
                ['vehicle']: matchingCar?.title,
                ['initial']: matchingCar?.initial,
                ['monthly']: matchingCar?.monthly,
                ['month']: matchingCar?.month,
                ['regionType']: regionType
            }))

            setOpenEnquire(true)
            // document
            //   .getElementById("contactForm")
            //   .scrollIntoView({ behavior: "smooth" });

            // Set focus on the email input field
            // if (vehicleRef.current) {
            //   vehicleRef.current.focus();
            // }
        } else {
            alert(`Car "${carName}" not found in vehicleInfo array`)
        }
    }

    return (
        <Card
            elevation={0}
            sx={{
                // height: "100%",
                borderRadius: 5,
                border: `1px solid ${BORDER}`,
                overflow: "visible",
                bgcolor: "#fff",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                },
            }}
        >
            {/* Image header */}
            <Box sx={{ position: "relative", p: 1 }}>
                <Box
                    sx={{
                        position: "relative",
                        // height: 300,
                        height: { xs: 260, sm: 240, md: 220, lg: 265, xl: 265 },
                        borderRadius: 4,
                        overflow: "hidden",
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            borderRadius: "inherit",
                            padding: "1px",                    // border thickness
                            background: PRIMARY_GRADIENT,
                            WebkitMask:
                                "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                            WebkitMaskComposite: "xor",
                            maskComposite: "exclude",
                            pointerEvents: "none",
                        },
                    }}
                >
                    <img src={`${process.env.IMAGE_BASE_URL}/${image}`} alt={title}
                        style={{ objectFit: "contain", height: "auto", bottom: "20px", position: "absolute", width: "95%", left: "12px" }}
                    />

                    {/* ROI pill – anchor INSIDE the image box */}
                    <Box
                        sx={{
                            position: "absolute",
                            top: 12,
                            left: 14,
                            p: 0.75,
                            borderRadius: "9999px",
                            background: "linear-gradient(180deg, #75C4C5 0%, #0D8196 100%)",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 11,
                            lineHeight: 1.3,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {`Apr. Annual ROI - ${roiPercentage}%`}
                    </Box>

                </Box>
            </Box>


            {/* Body */}
            <CardContent sx={{ pt: 0, pb: 2.5 }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 800,
                        textAlign: "center",
                        mt: 0.5,
                        mb: 1,
                    }}
                >
                    {title}
                </Typography>

                {/* infoList row */}
                <Stack direction="row" spacing={1.5} sx={{ alignItems: "stretch" }}>
                    {infoList?.slice(0, 3).map((s, i) => (
                        <Box
                            key={i}
                            sx={{
                                flex: "1 1 0",
                                minWidth: 0,
                                bgcolor: "#f6f6f6",
                                borderRadius: 3,
                                border: "1px solid #e5e5e5",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* Header (exactly 3 lines of height) */}
                            <Box sx={{ px: 1.5, py: 1.25 }}>
                                <Typography
                                    sx={{
                                        color: "#7d7d7d",
                                        fontWeight: 600,
                                        fontSize: { xs: 10, lg: 14 },
                                        textAlign: "center",
                                        lineHeight: "1.35em",
                                        display: "flex",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        wordBreak: "break-word",
                                        minHeight: "calc(1.35em * 3)",
                                        maxHeight: "calc(1.35em * 3)",
                                        alignItems: "center"
                                    }}
                                >
                                    {s.label}
                                </Typography>
                            </Box>

                            <Divider sx={{ bgcolor: "#e5e5e5" }} />

                            {/* Value (exactly 1 line of height) */}
                            <Box sx={{ px: 1.5, py: 1.25, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: { xs: 12, md: 12, lg: 15 },
                                        lineHeight: "1.2em",
                                        minHeight: "1.2em",
                                        whiteSpace: "nowrap", // prevent wrap so heights match
                                        textAlign: "center",
                                        minWidth: 0,
                                    }}
                                >
                                    {CurrencySimple(s.value, "#000000de", responsiveSize)}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>


            </CardContent>

            {/* Ticket seam with notches + footer */}
            <Box
                sx={{
                    position: "relative",
                    borderTop: `1px solid ${BORDER}`,
                    py: 1,
                    // no horizontal padding here; move it to an inner wrapper
                    "&:before, &:after": {
                        content: '""',
                        position: "absolute",
                        top: -9.5,                // center the 18px circle on the 1px seam
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        backgroundColor: surfaceColor, // page color for true "cutout"
                        // boxShadow: `inset 0 0 0 1px ${surfaceColor}`,
                        pointerEvents: "none",
                        border: `1px solid ${BORDER}`,
                        transform: "translateY(-0.5px)",
                    },
                    "&:before": { left: -9, clipPath: "inset(0 0 0 8px)" },
                    "&:after": { right: -9, clipPath: "inset(0 8px 0 0)", },
                }}
            >
                {/* inner content gets the horizontal padding */}
                <Box sx={{ textAlign: "center" }}>
                    <Typography
                        sx={{ fontWeight: 500 }}
                        variant="subtitle"
                    >
                        {bottomLabel}
                    </Typography>

                    <Grid container spacing={2} justifyContent="center" sx={{ mb: 2, mt: "0px" }}>
                        <Grid item xs={10} sm={8} md={9} lg={10}>
                            <ValuePill value={pricePeriod?.[0]?.price} suffix={pricePeriod?.[0]?.period} />
                        </Grid>

                        <Grid item xs={11} sm={9} md={10} lg={11}>
                            <ValuePill value={pricePeriod?.[1]?.price} suffix={pricePeriod?.[1]?.period} />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center">
                        {/* Book a Call */}
                        <Grid item>
                            <CtaButton label="Book a Call"
                                onClick={() => window.open(process.env.BOOK_A_CALL, "_blank")}
                            />
                        </Grid>

                        {/* WhatsApp */}
                        <Grid item>
                            {/* <Button
                                variant="contained"
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: 999,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: 16,
                                    color: "#fff",
                                    bgcolor: "#25D366",
                                    "&:hover": { bgcolor: "#1ec85e" },
                                }}
                                endIcon={
                                    <SvgIcon>
                                        <path
                                            d="M20.5 3.5A10 10 0 0 0 3.4 16.6L3 21l4.5-1.2A10 10 0 1 0 20.5 3.5Zm-8.4 3.6c.3 0 .7.1 1 .7.2.6.6 1.9.6 1.9s.1.3 0 .5c-.1.2-.2.3-.4.5-.2.2-.3.4-.1.7.2.3.9 1.5 2.2 2.3 1.1.6 1.4.5 1.7.4.3-.1.8-.6 1-.8.2-.2.3-.2.5-.1.2.1 1.3.6 1.3.6s.4.2.4.4c0 .2.1 1.1-.5 1.8-.6.8-1.6.9-2.1.8-.6-.1-1.3-.3-2.2-.8-1-.5-2.2-1.3-3.3-2.5-1.2-1.1-2-2.3-2.5-3.3-.5-.9-.7-1.6-.8-2.2-.1-.5 0-1.5.8-2.1.7-.6 1.6-.5 1.8-.5Z"
                                            fill="currentColor"
                                        />
                                    </SvgIcon>
                                }
                            >
                                Send a message
                            </Button> */}
                            <DynamicPillButton
                                label="Send a message"
                                icon="/img/header/whatsapp.svg"
                                iconPosition="end"
                                bg="#25D366"
                                onClick={() => openWhatsAppChat(`${title}(${name})`, "investing")}
                                size="md"
                                sx={{ height: "47px !important" }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Divider sx={{ bgcolor: "#9d9fa4", m: 2 }} />
                {/* Dropdown header row */}
                <Box
                    role="button"
                    aria-expanded={isOpen}
                    aria-controls={`breakdown-${title}`}
                    tabIndex={0}
                    onClick={onToggle}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") onToggle?.();
                    }}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "#111827",
                        fontWeight: 600,
                        fontSize: 14,
                        gap: 1,
                        // py: 1.5,
                        "&:hover": { backgroundColor: "#fafafa" },
                    }}
                >
                    <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                        Monthly Expense Breakdown
                    </Typography>
                    <SvgIcon sx={{ transition: "transform .2s", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}>
                        <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </SvgIcon>
                </Box>

                <Box id={`breakdown-${title}`} sx={{ px: 2, py: isOpen ? 2 : 0 }}>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <Grid container spacing={1.5} sx={{ pt: 0.5 }}>
                            {breakdown?.map((row, idx) => (
                                <Grid key={idx} item xs={12} sm={4} md={4}>
                                    <Box
                                        sx={{
                                            bgcolor: "#f6f6f6",
                                            border: "1px solid #e5e7eb",
                                            borderRadius: 2.5,
                                            // px: 1,
                                            py: 0.5,
                                            textAlign: "center",
                                            // height: 76,                       // consistent pill height
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            boxShadow: "0 1px 0 rgba(0,0,0,0.02) inset",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#94969a",
                                                fontWeight: 700,
                                                fontSize: { xs: 12, md: 14 },
                                                mb: 0.5,
                                            }}
                                        >
                                            {row.label}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontWeight: 800,
                                                fontSize: { xs: 14, md: 16 },
                                                lineHeight: 1.1,
                                                color: "#111827",
                                            }}
                                        >
                                            {row.value}{" "}
                                            {row.unit ? (
                                                <Box component="span" sx={{ fontWeight: 700, fontSize: 14 }}>
                                                    {row.unit}
                                                </Box>
                                            ) : null}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Collapse>
                </Box>
            </Box>
        </Card >
    );
}

// --- Rounded grey pill line item ---
function ValuePill({
    value,
    suffix
}) {
    const responsiveSize = useResponsiveValue({ xs: 16, sm: 11, lg: 17 });
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
                gap: "2px",
                borderRadius: 3,
                bgcolor: "#f3f4f6",
                border: "1px solid #e5e7eb",
                boxShadow: "0 1px 0 rgba(0,0,0,0.02) inset",
            }}
        >
            <Typography
                sx={{
                    fontWeight: 800,
                    fontSize: { xs: 16, sm: 11, lg: 17 },
                    lineHeight: 1.15,
                    // mt: 0.5,
                    display: "flex",
                    gap: "4px",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: 0,
                }}
            >
                {CurrencySimple(value, "#000000de", responsiveSize)}
            </Typography>

            <Typography
                sx={{ color: "#9ca3af", fontWeight: 500, fontSize: { xs: 16, sm: 11, lg: 17 } }}
            >
                {suffix}
            </Typography>
        </Box>
    );
}